import { render, staticRenderFns } from "./Box12.vue?vue&type=template&id=435aff42&scoped=true&"
import script from "./Box12.vue?vue&type=script&lang=js&"
export * from "./Box12.vue?vue&type=script&lang=js&"
import style0 from "./Box12.vue?vue&type=style&index=0&id=435aff42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435aff42",
  null
  
)

export default component.exports